import { render } from "./Returns.vue?vue&type=template&id=bec3a3c8&scoped=true"
import script from "./Returns.vue?vue&type=script&lang=js"
export * from "./Returns.vue?vue&type=script&lang=js"

import "./Returns.vue?vue&type=style&index=0&id=bec3a3c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bec3a3c8"]])

export default __exports__